module.exports = __webpack_public_path__ + "img/betflix-support.418ef8dd.png";